<template>
  <div class="adv-search space-top-2">
    <search-bar
      v-for="(inputGroup, idx) in advSearchRefs.inputGroups"
      :key="idx + '-key'"
      :idx="idx"
      :inputGroup="inputGroup"
      :opts="options"
      @updateInput="updateInputGroup"
      @addSearchBar="addInputGroup"
      @removeSearchBar="removeInputGroup"
    >
    </search-bar>
  </div>
</template>

<script setup>
  import { reactive, onBeforeMount, getCurrentInstance, ref } from "vue";
  import SearchBar from "./_advanced-search-bar.vue";
  import useAdvancedSearch from "../composables/useAdvSearch";
  const instance = getCurrentInstance()
  const global = instance.appContext.config.globalProperties;

  const props = defineProps({
    queryObj: Object,
    queryOpts: Object,
  });

  const {
    advSearchRefs,
    addInputGroup,
    removeInputGroup,
    updateInputGroup,
    parseQueryString
  } = useAdvancedSearch();

  const options = {
    bool: advSearchRefs.boolOpts,
    fields: advSearchRefs.fieldOpts,
  };

  onBeforeMount(() => {
    parseQueryString(props.queryObj.q);
  });

</script>